import { createLoadable } from '@main/core-ui';

// Load the component dynamically
export default createLoadable({
  loader: () => import('./index'),
});
